module.exports = __webpack_public_path__ + "static/media/PORTADA.fdb6c1c9.jpg";